import React, { useContext, useEffect, useState } from "react";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/bootstrap.css"
import { Link, useNavigate } from "react-router-dom";
import { useRef } from "react";
import { allTimeZone } from "./Countrycode";
import { lang } from "../../lang";
import { loginUrl } from "../../Service/service";
import { postData } from "../../Service/ApiMethod";
import "react-phone-input-2/lib/bootstrap.css"
import Geocode from "react-geocode";
import { useTranslation } from "react-i18next";
export default function Seekeraccountdelete() {
  const [ln, setLn] = useState('en')
  const [phone, setPhone] = useState();
  const [password, setPassword] = useState();
  const [error, setError] = useState();
  const [showPassword, setShowPassword] = useState(false)
  const [value, setValue] = useState()
  const [latitude, setLatitude] = useState();
  const [longitude, setLongitude] = useState();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const countryCode = useRef(null)
  const [countryCod, setCountrycod] = useState('fi')
  useEffect(() => {
    const tokens = localStorage.getItem("catzapp_token");
    const url = window.location.href;
    if (url) {
      const idMatch = url.match(/[\?&]id=(\d+)/);
      const id = idMatch ? idMatch[1] : null;

      console.log("id:", id);
      if (id != null) {
        if (tokens == null) {
          localStorage.setItem("seekershareid", id)
        } else {
          localStorage.setItem("seekershareid", id)
          setTimeout(() => {
            navigate('/home')
          }, 1500)
        }

      }
    }



    // console.log(localStorage.getItem("language"),"checkkkkkk2222222",ln)
    if (localStorage.getItem("language") != null) {
      // localStorage.removeItem("catzapp_token")
      setLn(localStorage.getItem("language"))
    }
    // if(localStorage.getItem("language") != null){
    // setLn(localStorage.getItem("language"))

    locations()
  })

  const locations = async () => {

    if (navigator?.geolocation) {
      await navigator?.geolocation?.getCurrentPosition(function (position) {
        console.log("Latitude is :", position?.coords?.latitude);
        console.log("Longitude is :", position?.coords?.longitude);

        setLatitude(position?.coords?.latitude);
        setLongitude(position?.coords?.longitude);
        localStorage.setItem('lat', position?.coords?.latitude);
        localStorage.setItem('lng', position?.coords?.longitude);
        const latitude = position.coords.latitude;
        const longitude = position.coords.longitude;
        const reverseGeocodingUrl = `https://maps.googleapis.com/maps/api/geocode/json?latlng=${latitude},${longitude}&key=AIzaSyAn7_5pFRSJ_i1lbbiitBzZinnYY7VTGxk`;

        // call Reverse Geocoding API - https://www.geoapify.com/reverse-geocoding-api/
        fetch(reverseGeocodingUrl)
          .then((response) => response.json())
          .then((data) => {
            if (data.status === 'OK') {
              var address = data.results[0].address_components;
              const countryComponent = data.results[0].address_components.find(
                component => component.types.includes('country')
              );

              if (countryComponent) {
                const countryShortCode = countryComponent.short_name;
                console.log(countryShortCode, "ssssss"); // Display the country short code
                allTimeZone.map((item) => {
                  if (item.Code == countryShortCode) {
                    console.log(item.Code.toLowerCase(), "onnnnnnnn000000", countryCode.current);
                    countryCode.current = item.Code.toLowerCase()
                    setCountrycod(item.Code.toLowerCase())
                  }
                })
              }

              // Do something with the address
              console.log(address, "0000000000000000000000000000000000000000000000");
            } else {
              // Handle the error case
              // console.log('Error: ' + data.status);
            }
          })
          .catch((error) => {
            // console.log('Error: ' + error.message);
          });

      }, function (error) {
        console.log(error);
      });

    } else {
      console.log('error in locating')
    }

  }

  const [loaderStart, setLoaderstart] = useState(false)
  const handleLogin = async () => {
    if(loaderStart == false){
      let values = {
        "user_types": "jobseeker",
        "phone": "+"+phone
      }
      console.log(values, "sda", phone)
      fetch("https://api.catzapp.com/send/otp/", {
        method: "POST",
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          // "accept": "application/json",
        },
        body: JSON.stringify(values),
      }).then((res) => {
        if (!res.ok) {
          throw new Error(`Network response was not ok: ${res.statusText}`);
        }
        return res.json(); // or res.text() or res.blob() based on the response type
      })
        .then((data) => {
          console.log(data, "okkkk")
          if (data.message != "") {
            alert(data.message)
            setLoaderstart(true)
          } else {
            alert(data.error_message)
          }
  
          // setData(data.data)
          // setListChange(false)
  
          // localStorage.setItem("token",data.token)
          // dispatch(loginUser(values, props.router.navigate));
        })
        .catch((error) => console.error("Error:", error));
    }else{
      
      let values = {
        "phone":"+"+phone,
        "otp":password,
        "user_types":"jobseeker"
    }
      console.log(values, "sda", phone)
      fetch("https://api.catzapp.com/verify/otp/", {
        method: "POST",
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          // "accept": "application/json",
        },
        body: JSON.stringify(values),
      }).then((res) => {
        if (!res.ok) {
          throw new Error(`Network response was not ok: ${res.statusText}`);
        }
        return res.json(); // or res.text() or res.blob() based on the response type
      })
        .then((data) => {
          console.log(data, "okkkk")
          if (data.message != "") {
            alert(data.message)
            deletefunc(data.data.access)
            
            setLoaderstart(true)
            
          } else {
            alert(data.error_message)
          }
  
          // setData(data.data)
          // setListChange(false)
  
          // localStorage.setItem("token",data.token)
          // dispatch(loginUser(values, props.router.navigate));
        })
        .catch((error) => console.error("Error:", error));
    }
  }

const deletefunc =(tok)=>{
  let values = {
   "deletion_otp":password
}
  fetch("https://api.catzapp.com/jobseeker/delete_seeker/", {
    method: "POST",
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      Authorization: "Bearer " + tok,
      // "accept": "application/json",
    },
    body: JSON.stringify(values),
  }).then((res) => {
    if (!res.ok) {
      throw new Error(`Network response was not ok: ${res.statusText}`);
    }
    return res.json(); // or res.text() or res.blob() based on the response type
  })
    .then((data) => {
      console.log(data, "okkkk")
      if (data.message != "") {
        alert(data.message)
        setLoaderstart(false)
        setPhone()
        setPassword()
      } else {
        alert(data.error_message)
      }

      // setData(data.data)
      // setListChange(false)

      // localStorage.setItem("token",data.token)
      // dispatch(loginUser(values, props.router.navigate));
    })
    .catch((error) => console.error("Error:", error));
}


  return (
    <div style={{ justifyContent: 'center', width: 'fit-content', margin: "0 auto" }}>
      <div className="">
        <div className="input-container my-2">
          <PhoneInput inputStyle={{ width: '100%', fontSize: '21px', border: '0.5px solid gray' }}
            inputClassName='reactphoneinput'
            placeholder={t("Enter Mobile Number")}
            type='text'
            country={countryCod}
            enableSearch={true}
            defaultValue='+358'
            onChange={(phone) => { setPhone(phone) }}
            name=''
            id='phone'
            onKeyDown={e => e.key === 'Enter' ? handleLogin() : ''}
          />

          {/* <input
            className="input-text w-100 pl-5"
            placeholder="Enter Mobile Number"
            type="text"
            defaultValue='+91'
            onChange={(e) => { setPhone(e.target.value) }}
            name=""
            id="phone"
          /> */}
          {/* <img src="./images/call.png" alt="" className="left-img" /> */}
        </div>
        {
          loaderStart == true ? (<div className="input-container my-2 mt-3">
            <input
              className="input-text w-100 pl-5 passwordLoginInput" style={{ borderRadius: "5px" }}
              placeholder={"Enter OTP"}
              type={showPassword ? 'text' : "password"}
              // type="password"
              onChange={(e) => { setPassword(e.target.value) }}
              name=""
              id="pwd"
              onKeyDown={e => e.key === 'Enter' ? handleLogin() : ''}
            />
            <span onClick={() => setShowPassword(!showPassword)} style={{ cursor: 'pointer', position: 'absolute', right: '15px', top: '30%' }} >
              {showPassword ? <i className="fa fa-eye" aria-hidden="true" /> : <i class="fa fa-eye-slash" aria-hidden="true" />}
            </span>
            <img src="./images/lock.png" alt="" className="left-img" />
          </div>) : null
        }
      </div>
      <button className="theme-btn mt-1" type="submit" onClick={handleLogin} onKeyDown={e => e.key === 'Enter' ? handleLogin() :
        ''} >
        submit
      </button>
    </div>
  )
}
